import { EvidenceDocument } from "models/shared/interfaces/shared.interface";

export interface VehicleRatingsData {
  performance: number;
  power: number;
  stability: number;
  design: number;
}

export interface VehicleReviewer {
  _id: string;
  name: string;
  lastName: string;
}

export interface VehicleReviewData {
  _id: string;
  brand: string;
  model: string;
  cc: number;
  year: number;
  reviewerId: VehicleReviewer;
  deliveryPhoto: EvidenceDocument;
  reviewTitle: string;
  reviewContent: string;
  ratings: VehicleRatingsData;
  createdAt: Date;
  updatedAt: Date;
}

export class VehicleReview implements VehicleReviewData {
  _id: string;
  brand: string;
  model: string;
  cc: number;
  year: number;
  reviewerId: VehicleReviewer;
  deliveryPhoto: EvidenceDocument;
  reviewTitle: string;
  reviewContent: string;
  ratings: VehicleRatingsData;
  createdAt: Date;
  updatedAt: Date;

  constructor(_: VehicleReviewData) {
    this._id = _._id;
    this.brand = _.brand;
    this.model = _.model;
    this.cc = _.cc;
    this.year = _.year;
    this.reviewerId = _.reviewerId;
    this.deliveryPhoto = _.deliveryPhoto;
    this.reviewTitle = _.reviewTitle;
    this.reviewContent = _.reviewContent;
    this.ratings = _.ratings;
    this.createdAt = _.createdAt;
    this.updatedAt = _.updatedAt;
  }

  getGlobalRating() {
    return (
      this.ratings.performance +
      this.ratings.power +
      this.ratings.stability +
      this.ratings.design) / 4;
  }
}
